import React from 'react';
import { Helmet } from 'react-helmet';
import './pagestyles/Graphics.css';

const Graphics = () => {
  return (
    <>
      <Helmet>
        <title>Graphics - Data Visualization & Infographics | Redbox Global</title>
        <meta name="description" content="Explore Redbox Global's data visualizations, interactive charts, and infographics that bring business and economic data to life. Visual storytelling through data." />
        <meta name="keywords" content="data visualization, infographics, business charts, economic graphics, interactive charts, data journalism, visual storytelling, business graphics" />
        
        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://redboxglobal.com/graphics" />
        <meta property="og:title" content="Graphics - Data Visualization & Infographics | Redbox Global" />
        <meta property="og:description" content="Data visualizations and infographics that bring business and economic data to life." />
        <meta property="og:image" content="https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=1200&h=630&fit=crop" />
        
        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:url" content="https://redboxglobal.com/graphics" />
        <meta name="twitter:title" content="Graphics - Data Visualization & Infographics | Redbox Global" />
        <meta name="twitter:description" content="Data visualizations and infographics that bring business and economic data to life." />
        <meta name="twitter:image" content="https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=1200&h=630&fit=crop" />
        
        {/* Additional SEO */}
        <meta name="robots" content="index, follow" />
        <meta name="author" content="Redbox Global" />
        <link rel="canonical" href="https://redboxglobal.com/graphics" />
      </Helmet>
      
      <div className="page-container">
        <div className="page-header">
          <h1>Graphics</h1>
          <p className="page-subtitle">Visual storytelling through data, charts, and interactive infographics</p>
        </div>
        
        <div className="page-content">
          <a href="/article/global-economy-2026-visualization" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
            <div className="featured-article">
              <div className="featured-image">
                <img src="https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=1200&h=600&fit=crop" alt="Data visualization" />
              </div>
              <div className="featured-content">
               
                <h2>The Global Economy in 2026: A Visual Journey</h2>
                <p>Navigate through interactive charts and maps showing GDP growth, trade flows, currency movements, and economic indicators across 195 countries. Our comprehensive visualization reveals the interconnected nature of global commerce and highlights emerging economic powerhouses.</p>
                <span className="article-meta">Interactive • Updated Daily</span>
              </div>
            </div>
          </a>

          <div className="content-grid">
            <a href="/article/market-performance-charts" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
              <article className="article-card">
                <div className="article-image">
                  <img src="https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=600&h=400&fit=crop" alt="Market charts" />
                </div>
                <div className="article-content">
                  
                  <h2>Year-to-Date Market Performance</h2>
                  <p>Interactive charts tracking major indices, sectors, and individual stocks across global markets.</p>
                  <span className="article-meta">Updated Real-Time</span>
                </div>
              </article>
            </a>

            <a href="/article/climate-data-visualization" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
              <article className="article-card">
                <div className="article-image">
                  <img src="https://images.unsplash.com/photo-1569163139394-de4798aa62b6?w=600&h=400&fit=crop" alt="Climate data" />
                </div>
                <div className="article-content">
                  
                  <h2>Climate Investment Tracker</h2>
                  <p>Visual breakdown of global green energy investments and carbon reduction initiatives.</p>
                  <span className="article-meta">Monthly Update</span>
                </div>
              </article>
            </a>

            <a href="/article/tech-valuations-infographic" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
              <article className="article-card">
                <div className="article-image">
                  <img src="https://images.unsplash.com/photo-1504868584819-f8e8b4b6d7e3?w=600&h=400&fit=crop" alt="Tech valuations" />
                </div>
                <div className="article-content">
                  
                  <h2>Tech Giants: Valuation Comparison</h2>
                  <p>Comprehensive infographic comparing market caps, revenues, and growth trajectories.</p>
                  <span className="article-meta">Quarterly</span>
                </div>
              </article>
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default Graphics;
